import React from 'react';
import { LogOut, X, ShieldAlert } from 'lucide-react';

export default function LogoutModal({ isOpen, onClose, onConfirm }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-in fade-in duration-300">
            {/* Modal Container */}
            <div className="w-full max-w-md bg-[#0c0c18] border border-white/10 rounded-3xl p-8 shadow-2xl relative overflow-hidden animate-in zoom-in-95 duration-300">
                
                {/* Neon Top Line */}
                <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-cyber-pink via-cyber-purple to-cyber-blue"></div>
                
                {/* Decorative background glow */}
                <div className="absolute -top-24 -right-24 w-48 h-48 bg-cyber-pink/10 rounded-full blur-[60px] pointer-events-none"></div>
                <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-cyber-blue/10 rounded-full blur-[60px] pointer-events-none"></div>

                {/* Close Button */}
                <button 
                    onClick={onClose}
                    className="absolute top-6 right-6 p-2 rounded-xl bg-white/5 border border-white/10 text-gray-400 hover:text-white hover:border-white/20 transition-all"
                >
                    <X className="w-5 h-5" />
                </button>

                <div className="text-center space-y-6 pt-4">
                    {/* Icon Header */}
                    <div className="w-20 h-20 bg-cyber-pink/10 rounded-3xl flex items-center justify-center mx-auto border border-cyber-pink/20 relative group">
                        <div className="absolute inset-0 bg-cyber-pink/20 rounded-3xl blur-xl opacity-50 group-hover:opacity-100 transition-opacity"></div>
                        <LogOut className="w-10 h-10 text-cyber-pink relative z-10" />
                    </div>

                    <div className="space-y-2">
                        <h3 className="text-2xl font-cyber font-black text-white uppercase tracking-tight">Confirm Logout</h3>
                        <p className="text-gray-400 text-sm leading-relaxed font-sans">
                            Are you sure you want to log out of your account?
                        </p>
                    </div>

                    <div className="flex gap-4 pt-4">
                        <button 
                            onClick={onClose}
                            className="flex-1 py-4 rounded-2xl bg-white/5 border border-white/10 text-gray-400 font-cyber font-bold text-[10px] uppercase tracking-widest hover:bg-white/10 hover:text-white transition-all"
                        >
                            Cancel
                        </button>
                        <button 
                            onClick={onConfirm}
                            className="flex-1 py-4 rounded-2xl bg-cyber-pink/20 border border-cyber-pink/40 text-cyber-pink font-cyber font-bold text-[10px] uppercase tracking-widest hover:bg-cyber-pink/30 shadow-[0_0_20px_rgba(255,0,122,0.1)] transition-all flex items-center justify-center gap-2"
                        >
                            <LogOut className="w-3.5 h-3.5" />
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
